/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class EvmSecondlyScheduleControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setHomeTrxTokenTotalCount(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/secondly/transaction/token/total/count',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setHomeTrxTokenTotalCount1(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/secondly/transaction/token/total/count',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public processPendingTransaction(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/secondly/transaction/pending',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public processPendingTransaction1(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/secondly/transaction/pending',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setHomeTrxClaimTotalCount(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/secondly/transaction/claim/total/count',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setHomeTrxClaimTotalCount1(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/secondly/transaction/claim/total/count',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setMetaDataErc721(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/secondly/token/metadata/erc721',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setMetaDataErc7211(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/secondly/token/metadata/erc721',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setMetaDataErc1155(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/secondly/token/metadata/erc1155',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setMetaDataErc11551(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/secondly/token/metadata/erc1155',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setNativeTokenTotalSupply(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/secondly/native-token/total-supply',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setNativeTokenTotalSupply1(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/secondly/native-token/total-supply',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setGeneralSummaryGasPrice(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/secondly/general/summary/gasprice',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setGeneralSummaryGasPrice1(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/secondly/general/summary/gasprice',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setEtherScanGetAbi(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/secondly/etherscan/getabi',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setEtherScanGetAbi1(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/secondly/etherscan/getabi',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setBlockBaseFeeAndGasUsed(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/secondly/block/gas',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setBlockBaseFeeAndGasUsed1(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/secondly/block/gas',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setBlockAvgCreatedTime(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/secondly/block/avgcreatedtime',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setBlockAvgCreatedTime1(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/secondly/block/avgcreatedtime',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setHomeTotalAccount(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/secondly/address/total/count',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setHomeTotalAccount1(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/secondly/address/total/count',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setHomeTotalBalance(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/secondly/address/total/balance',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setHomeTotalBalance1(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/secondly/address/total/balance',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setSignatureMethod(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/schedule/secondly/address/signaturemethod',
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setSignatureMethod1(): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/secondly/address/signaturemethod',
        });
    }

}
